import React, { useState } from 'react'
import { connect } from 'react-redux'
// import history from 'core/history';


const Nav = (props) => {
    const {
      
    } = props
  



    return (
        <>
            {/* Header */}
            <nav className="bg-[#FBC558]  w-full fixed z-10   ">
                <div className="  h-16  w-full grid grid-cols-2 gap-4 justify-center items-center ">
                  Nav
                </div>
            </nav>
        

        </>
    )
}

const mapStateToProps = (state) => {
    return {
    
    }
}

const mapDispatchToProps = {
   
}

export default connect(mapStateToProps, mapDispatchToProps)(Nav)